import { useState, useRef, useEffect } from 'react';
import { formatPoinNumber } from './tukarPoin';
import { shouldNavigateToCouponDetails } from '../navigation/navigateToClaimedCoupon';
import { View, Text, StyleSheet, Animated, Image } from 'react-native';
import { Audio } from 'expo-av';
import { Howl } from 'howler';

export { formatPoinNumber };

const SCAN_ERROR_TYPES = [
  'invalid',
  'already_scanned',
  'already_used',
  'expired',
  'network',
  'error',
  'session_expired',
];

export function qrRewardSourceName(qrCode) {
  const brand = String(qrCode?.brand?.nama || '').trim();
  if (brand) return brand;
  return null
}

export function scanPointsFromLabel(points, qrCode) {
  const n = Number(points) || 0;
  const unit = n === 1 ? 'point' : 'points';
  const source = qrRewardSourceName(qrCode);
  return source
    ? `${formatPoinNumber(n)} ${unit} dari ${source}`
    : `${formatPoinNumber(n)} ${unit}`;
}

export function scanStampsFromLabel(stamps, qrCode) {
  const n = Number(stamps) || 0;
  const unit = n === 1 ? 'e-stamp' : 'e-stamps';
  const source = qrRewardSourceName(qrCode);
  return source
    ? `${formatPoinNumber(n)} ${unit} dari ${source}`
    : `${formatPoinNumber(n)} ${unit}`;
}

export function isPointsScanSuccessWithoutCoupon(scanResult) {
  if (!scanResult) return false;
  if (SCAN_ERROR_TYPES.includes(scanResult.type)) return false;
  if (shouldNavigateToCouponDetails(scanResult)) return false;
  return (Number(scanResult.rewards?.points) || 0) > 0
    || String(scanResult.type || '').includes('points');
}

export const SCAN_CLAIM_PRIZES = [
  { emoji: '🚗', label: 'Mobil' },
  { emoji: '🏍️', label: 'Motor' },
  { emoji: '🔥', label: 'Hexohm & Hexpod' },
  { emoji: '👕', label: 'Ratusan T-shirt' },
];

export function PointRewardHint({}) {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.text}>Langsung tukarkan dengan:</Text>
      <Text style={styles.text}>Dana, Voucher Indomaret, dll.</Text>
      <Text style={styles.text}>Di menu <Text style={styles.highlight}>Tukar Poin</Text></Text>
      {/*<Text style={styles.note}>1 point (± Rp 100)</Text>*/}
    </View>
  );
}

export function useConfettiAndClap() {
  const [confettiVisible, setConfettiVisible] = useState(false);
  const confettiOpacity = useRef(new Animated.Value(1)).current;
  const [audioSound, setAudioSound] = useState(null);
  const howlSound = useRef(null);

  useEffect(() => {
    if (! confettiVisible) {
      confettiOpacity.setValue(1);
    } else {
      confettyFadeOut();
    }
  }, [confettiVisible]);

  const showConfetti = () => {
    setConfettiVisible(true);
  }

  const playClappingSound = async () => {
    try {
      // const { sound } = await Audio.Sound.createAsync(
      //   require('../../assets/clap.mp3')
      // );
      // setAudioSound(sound);
      // await sound.playAsync();

      if (! howlSound.current) {
        howlSound.current = new Howl({
          src: [require('../../assets/clap.mp3')],
          // onplay: () => {
          //   console.log('played');
          // },
        });
      }
      
      howlSound.current.play();
    } catch (error) {
      console.log('Error playing sound:', error);
    }
  }

  const confettyFadeOut = () => {
    playClappingSound();

    Animated.timing(confettiOpacity, {
      toValue: 0,
      duration: 4000,
      useNativeDriver: true,
    }).start(({finished}) => {
      if (finished) {
        setConfettiVisible(false);
        // if (audioSound) {
        //   audioSound.unloadAsync();
        // }

        // if (howlSound.current) {
        //   howlSound.current.unload();
        // }
      }
    });
  }

  const confettiWrapper = confettiVisible 
    ? (
      <Animated.View style={[styles.confettiWrapper, { opacity: confettiOpacity }]}>
        <Image 
          source={require('../../assets/confetti-big.gif')} 
          style={styles.confetti}
          resizeMode="cover"
        />
      </Animated.View>
    )
    : null;

  return { confettiWrapper, showConfetti };
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 0, 
    paddingBottom: 4,
    paddingHorizontal: 16,
    marginBottom: 8,
  },
  text: {
    fontSize: 13, 
    color: '#000000',
    lineHeight: 20,
    fontFamily: 'Poppins-Medium',
    fontWeight: 500,
  },
  highlight: {
    fontFamily: 'Poppins-SemiBold',
    fontWeight: 600,
  },
  note: {
    fontSize: 12, 
    color: '#000000',
    lineHeight: 16,
    fontFamily: 'Poppins-Medium',
    fontWeight: 500,
    marginTop: 2,
  },

  confettiWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 5,
  },
  confetti: {
    width: '100%',
    height: '100%',
  },

});
